import React, { Fragment, useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { DashboardContext } from "./";
import { todayAllOrders } from "./Action";

const SellTable = () => {
  const history = useHistory();
  const { data, dispatch } = useContext(DashboardContext);

  useEffect(() => {
    todayAllOrders(dispatch);
  }, []);

  const ordersList = () => {
    let newList = [];
    if (data.totalOrders.Orders !== undefined) {
      data.totalOrders.Orders.forEach(function (elem) {
        if (
          elem.createdAt &&
          moment(elem.createdAt).format("LL") === moment().format("LL")
        ) {
          newList = [...newList, elem];
        }
      });
    }
    return newList;
  };

  return (
    <Fragment>
      <div className="col-span-1 overflow-auto bg-white shadow-lg p-4">
        <div className="text-2xl font-semibold mb-6 text-center">
          Today's Orders{" "}
          {data.totalOrders.Orders !== undefined ? ordersList().length : 0}
        </div>

        <table className="table-auto border w-full my-2">
          <thead>
            <tr>
              <th className="px-4 py-2 border text-center">Products</th>
              <th className="px-4 py-2 border text-center">Customer</th>
              <th className="px-4 py-2 border text-center">Total</th>
              <th className="px-4 py-2 border text-center">Status</th>
              <th className="px-4 py-2 border text-center">Order Address</th>
              <th className="px-4 py-2 border text-center">Ordered at</th>
            </tr>
          </thead>

          <tbody>
            {data.totalOrders.Orders !== undefined ? (
              ordersList().map((item, key) => {
                return <TodayOrderTable order={item} key={key} />;
              })
            ) : (
              <tr>
                <td
                  colSpan="6"
                  className="text-xl text-center font-semibold py-8"
                >
                  No orders found today
                </td>
              </tr>
            )}
          </tbody>
        </table>

        <div className="text-sm text-gray-600 mt-2">
          Total{" "}
          {data.totalOrders.Orders !== undefined ? ordersList().length : 0}{" "}
          orders found
        </div>

        <div className="flex justify-center">
          <span
            onClick={() => history.push("/admin/dashboard/orders")}
            style={{ background: "#303031" }}
            className="cursor-pointer px-4 py-2 text-white rounded-full"
          >
            View All
          </span>
        </div>
      </div>
    </Fragment>
  );
};

const TodayOrderTable = ({ order }) => {
  return (
    <Fragment>
      <tr>
        <td className="p-2 text-center text-sm text-gray-800">
          {order.allProduct.map((item, index) =>
            item.id ? (
              <div key={index}>
                {item.id.pName}{" "}
                <span className="ml-1">{item.quantity}x</span>
              </div>
            ) : null
          )}
        </td>

        <td className="p-2 text-center text-sm font-semibold text-gray-800">
          {order.user?.name || "Unknown Customer"}
        </td>

        <td className="p-2 text-center text-sm font-semibold text-gray-800">
          Rp {Number(order.amount).toLocaleString("id-ID")}
        </td>

        <td className="p-2 text-center">
          <span
            className={`block rounded-full text-center text-xs px-2 font-semibold ${
              order.status === "Not processed"
                ? "text-red-600"
                : order.status === "Processing"
                ? "text-yellow-600"
                : order.status === "Shipped"
                ? "text-blue-600"
                : order.status === "Delivered"
                ? "text-blue-600"
                : order.status === "Ready to pick up at the store"
                ? "text-green-600"
                : "text-red-600"
            }`}
          >
            {order.status}
          </span>
        </td>

        <td className="p-2 text-center">{order.address}</td>

        <td className="p-2 text-center">
          {order.createdAt
            ? moment(order.createdAt).format("lll")
            : "Invalid Date"}
        </td>
      </tr>
    </Fragment>
  );
};

const TodaySell = () => {
  return (
    <div className="m-4">
      <SellTable />
    </div>  
  );
};

export default TodaySell;